module.exports = __webpack_public_path__ + "static/media/tachometer-alt-average.27d4a131.svg";